module.exports = __webpack_public_path__ + "img/erp-logos_0020_reckon.5ebf7be4.jpg";